module.exports = __webpack_public_path__ + "static/media/USTw.fc1013fe.png";